import { render, staticRenderFns } from "./DashboardScenarioNotification.vue?vue&type=template&id=0cc1f4aa&scoped=true&"
import script from "./DashboardScenarioNotification.vue?vue&type=script&lang=js&"
export * from "./DashboardScenarioNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashboardScenarioNotification.vue?vue&type=style&index=0&id=0cc1f4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1f4aa",
  null
  
)

/* custom blocks */
import block0 from "./DashboardScenarioNotification.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports